import { isCorporativoProject } from './projectRouteAccess';

export const RRHH_CORPORATIVO_PROYECTO_KEY = 'rrhhCorporativoProyectoId';

export const getSelectedProject = () => {
  try {
    return JSON.parse(localStorage.getItem('selectedProject') || 'null');
  } catch {
    return null;
  }
};

export const isValidRrhhProyectoId = (id) =>
  id != null && id !== '' && Number(id) > 0;

/** Header X-Proyecto-ID para APIs RRHH cuando el contexto es corporativo. */
export const getRrhhProyectoHeaders = (proyectoId) => {
  if (!isValidRrhhProyectoId(proyectoId)) return {};
  return { 'X-Proyecto-ID': String(proyectoId) };
};

export const rrhhApiConfig = (proyectoId, extraHeaders = {}) => ({
  headers: { ...getRrhhProyectoHeaders(proyectoId), ...extraHeaders },
});

export const getRrhhProyectoIdFromSession = () => {
  const session = getSelectedProject();
  if (isCorporativoProject(session)) {
    try {
      const saved = localStorage.getItem(RRHH_CORPORATIVO_PROYECTO_KEY);
      return saved && isValidRrhhProyectoId(saved) ? Number(saved) : null;
    } catch {
      return null;
    }
  }
  return session?.id && isValidRrhhProyectoId(session.id) ? Number(session.id) : null;
};
